import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import SuperbuySpreadsheetGuide from "@/pages/article/superbuy-spreadsheet-guide/page";
import ShoesGuide from "@/pages/article/shoes-guide/page";
import VsAlternatives from "@/pages/article/vs-alternatives/page";
import BeginnerTutorial from "@/pages/article/beginner-tutorial/page";
import TipsTricks from "@/pages/article/tips-tricks/page";
import SafetyGuide from "@/pages/article/safety-guide/page";
import ProductDiscovery from "@/pages/article/product-discovery/page";
import Review2026 from "@/pages/article/review-2026/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/superbuy-spreadsheet-complete-guide",
    element: <SuperbuySpreadsheetGuide />,
  },
  {
    path: "/superbuy-spreadsheet-shoes-guide",
    element: <ShoesGuide />,
  },
  {
    path: "/superbuy-spreadsheet-vs-alternatives",
    element: <VsAlternatives />,
  },
  {
    path: "/superbuy-spreadsheet-beginner-tutorial",
    element: <BeginnerTutorial />,
  },
  {
    path: "/superbuy-spreadsheet-tips-tricks",
    element: <TipsTricks />,
  },
  {
    path: "/superbuy-spreadsheet-safety-guide",
    element: <SafetyGuide />,
  },
  {
    path: "/superbuy-spreadsheet-product-discovery",
    element: <ProductDiscovery />,
  },
  {
    path: "/superbuy-spreadsheet-review-2026",
    element: <Review2026 />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;